export const DISPLAY_SESSION_STORAGE_KEY = 'pokerroom-display-session';

export function readDisplaySessionCredential(storage: Pick<Storage, 'getItem'> = localStorage) {
  try {
    return storage.getItem(DISPLAY_SESSION_STORAGE_KEY)?.trim() ?? '';
  } catch {
    return '';
  }
}

export function clearDisplaySessionCredential(storage: Pick<Storage, 'removeItem'> = localStorage) {
  try {
    storage.removeItem(DISPLAY_SESSION_STORAGE_KEY);
  } catch {
    // Storage may be unavailable in private or locked-down browser modes.
  }
}

export function writeDisplaySessionCredential(
  credential: string,
  storage: Pick<Storage, 'setItem'> = localStorage,
) {
  const value = credential.trim();
  if (!value) return false;
  try {
    storage.setItem(DISPLAY_SESSION_STORAGE_KEY, value);
    return true;
  } catch {
    return false;
  }
}
